import { Button, Group, Stack, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { submitSupplier } from "api/supplier.service";
import React from "react";
import { Supplier } from "types/model.types";

import { notifications } from "@mantine/notifications";
import { safeApiCall } from "api/common.service";
import {
  MantineNotificationColor,
  MantineNotificationPosition,
  MSG_DEFAULT_FORM_INVALID,
  MSG_DEFAULT_FORM_SUBMIT_ERR,
  MSG_DEFAULT_FORM_SUBMIT_SUCCESS,
  MSG_DEFAULT_FORM_SUBMIT_TITLE_SAVE,
} from "common/constants";

interface SupplierEditFormProps {
  initial?: Supplier;
  onSaveComplete: (values: Supplier) => void;
  onCancel: () => void;
}

const AdminSupplierEntryPage: React.FC<SupplierEditFormProps> = ({
  initial,
  onSaveComplete,
  onCancel,
}) => {
  // Define our useForm and must be declared before any UseEffects
  const form = useForm<Supplier>({
    initialValues: {
      id: initial?.id ?? 0,
      total: initial?.total ?? 0,
      supplierName: initial?.supplierName ?? "",
      supplierCode: initial?.supplierCode ?? "",
    },
    validate: {
      supplierName: (v) => (!v ? "Supplier name is required" : null),
    },
  });

  const handleSubmit = async () => {
    const result = form.validate();
    if (result.hasErrors) {
      notifications.show({
        title: MSG_DEFAULT_FORM_SUBMIT_TITLE_SAVE,
        message: MSG_DEFAULT_FORM_INVALID,
        position: MantineNotificationPosition.TopCenter,
        color: MantineNotificationColor.Error,
      });
      return;
    }
    const payload: Supplier = form.getValues();
    try {
      const result = await safeApiCall(submitSupplier(payload));
      notifications.show({
        title: MSG_DEFAULT_FORM_SUBMIT_TITLE_SAVE,
        message: MSG_DEFAULT_FORM_SUBMIT_SUCCESS,
        position: MantineNotificationPosition.TopCenter,
        color: MantineNotificationColor.Success,
      });
      onSaveComplete(result);
    } catch {
      notifications.show({
        title: MSG_DEFAULT_FORM_SUBMIT_TITLE_SAVE,
        message: MSG_DEFAULT_FORM_SUBMIT_ERR,
        position: MantineNotificationPosition.TopCenter,
        color: MantineNotificationColor.Error,
      });
    }
  };

  return (
    <Stack>
      {/* Horizontal row */}
      <Group grow>
        <TextInput
          label="Supplier Id"
          disabled
          placeholder="Supplier Id"
          {...form.getInputProps("id")}
        />

        <TextInput
          label="Supplier Code"
          placeholder="Supplier Code"
          {...form.getInputProps("supplierCode")}
        />
      </Group>

      {/* Below the row */}
      <TextInput
        label="Supplier Name"
        placeholder="Enter supplier name"
        {...form.getInputProps("supplierName")}
      />

      <Group justify="flex-end" mt="md">
        <Button onClick={handleSubmit}>Save</Button>
        <Button onClick={onCancel}>Cancel</Button>
      </Group>
    </Stack>
  );
};

export default AdminSupplierEntryPage;
